import { isLayerService, ServiceConfiguration } from "../../../interfaces/resourceInfo";

export const getServiceConfiguration = (layer?: unknown): ServiceConfiguration => {
  const emptyServiceConfiguration: ServiceConfiguration = {
    name: "",
  };

  if (!isLayerService(layer) || !("configuration" in layer)) return emptyServiceConfiguration;

  return {
    ...emptyServiceConfiguration,
    ...(layer.configuration || {}),
  };
};
